import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { AuthContext } from "context";
import { createMRTColumnHelper } from "material-react-table";
import toast from "react-hot-toast";
import MDAlert from "../../components/MDAlert";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import GenericTable from "../genericTable.js";
// GraphQL import removed - now using REST API

function ManageYardSecurityAdmin() {
	const authContext = useContext(AuthContext);
	const [aree, setAree] = useState([]);
	const [areaSelect, setAreaSelect] = useState(localStorage.getItem("areaSelected"));
	const [showSideBar, setShowSideBar] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const [data, setData] = useState([]);

	const handleSetNotification = (msg, severityType) => {
		if (severityType === "success") {
			toast.success(msg, { id: "manage-yard-security-admin-toast" });
		} else {
			toast.error(msg, { id: "manage-yard-security-admin-toast" });
		}
	};

	function fetchData() {
		/*apiService.get('/area-management/', { }, {})
              .then(data => {
                setData(data);
              })
              .catch(error => handleSetNotification("Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #09930",'error'));*/
		apiService
			.get("/suppliers-management/", {}, {})
			.then((data) => {
				if (data) setData(data);
			})
			.catch((error) => {
				console.log(error);
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #09930",
					"error"
				);
			});
	}

	useEffect(() => {
		fetchData();
	}, []);

	const columnHelper = createMRTColumnHelper();

	const handleEdit = (id) => {
		navigate(`edit/${id}`);
	};

	async function deleteResource(id) {
		try {
			// Costruisci l'endpoint usando l'id fornito
			const endpoint = `/area-management/`;

			// Parametri opzionali per la richiesta DELETE
			const params = { id: id }; // Puoi aggiungere parametri se necessario
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id) {
		if (window.confirm("Sei sicuro di voler eliminare questo utente?\n Attenzione questa operazione è irreversibile.")) {
			deleteResource(id)
				.then((result) => {
					handleSetNotification("Utente eliminato con successo", "success");
					fetchData();
				})
				.catch((error) => {
					// Gestisci l'errore se non è stato gestito nella funzione
					handleSetNotification(
						"Si è verificato un errore durante l'eliminazione del utente. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #00032",
						"error"
					);
				});
		}
	}

	const columns = [
		columnHelper.accessor("name", {
			header: "Nome",
			size: 120,
		}),
		columnHelper.accessor("address", {
			header: "Documenti",
			size: 120,
			Cell: ({ row }) => (
				<MDButton
					onClick={() => navigate("/security-document-supplier-admin/" + row.original.id + "/" + row.original.name + "/")}
					size="small"
				>
					{" "}
					Vedi Documenti{" "}
				</MDButton>
			),
		}),
	];

	return (
		<DashboardLayout>
			{authContext.hasAuth("VIEW_SECURITY_MANAGMENT") ? (
				<>
					<DashboardNavbar />
					<MDBox pt={6} pb={3}>
						<MDTypography variant="h6" color="black">
							GESTIONE SICUREZZA
						</MDTypography>
					</MDBox>
					<GenericTable authModelName="SECURITY_MANAGMENT" data={data} columns={columns} disableButton={true} />
				</>
			) : (
				<MDBox sx={{ mt: 8 }}>
					<MDAlert color="error">Non hai i permessi per visualizzare questa pagina.</MDAlert>
				</MDBox>
			)}
		</DashboardLayout>
	);
}

export default ManageYardSecurityAdmin;
